import { Phone, MessageCircle } from 'lucide-react';

const FloatingButtons = () => {
  return (
    <div className="fixed bottom-24 right-4 z-40 flex flex-col gap-3" data-testid="floating-buttons">
      {/* Botón Llamar */}
      <a
        href="tel:858130213"
        className="floating-btn w-14 h-14 bg-[#1A365D] text-white rounded-full flex items-center justify-center shadow-lg animate-slide-up relative"
        aria-label="Llamar ahora"
        data-testid="floating-call-btn"
        style={{ animationDelay: '0.1s' }}
      >
        {/* Pulse Ring */}
        <span className="absolute inset-0 rounded-full bg-[#1A365D] animate-pulse-ring"></span>
        <Phone className="w-6 h-6 relative z-10" />
      </a>

      {/* Botón WhatsApp */}
      <a
        href="https://wa.me/34622339574?text=Hola,%20me%20gustaría%20solicitar%20información%20sobre%20sus%20productos."
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-lg animate-slide-up"
        aria-label="Contactar por WhatsApp"
        data-testid="floating-whatsapp-btn"
        style={{ animationDelay: '0.2s' }}
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </div>
  );
};

export default FloatingButtons;
